import { UntypedFormControl } from '@angular/forms';
import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';

import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { interceptorAvisouErro } from 'src/app/shared/http-interceptor/http-interceptor.module';
import { ICompany, IListByFilterEmpresas } from 'src/app/pages/companies/models/company.interface';
import { CompanyService } from 'src/app/pages/companies/services/company.service';
import { IListByFilterParceiros, IPartner } from 'src/app/pages/partners/models/partner.interface';
import { PartnerService } from 'src/app/pages/partners/services/partner.service';

@Component({
  selector: 'app-theme-settings ',
  templateUrl: './theme-settings.component.html',
  styleUrls: ['./theme-settings.component.scss']
})
export class ThemeSettingsComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private partnersSub?: Subscription;
  ERoleAdminString = ERoleAdminString;
  ordenarControl = new UntypedFormControl(1);
  acaoInput = new UntypedFormControl();
  companies: ICompany[] = [];
  partners: IPartner[] = [];
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  listOrder = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];
  constructor(
    private readonly companyService: CompanyService,
    private readonly sessionService: SessionService,
    private readonly partnerService: PartnerService,
    private readonly toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.ordenarControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((ordenacao) => {
      this.dadosPaginacao.ordenacao = ordenacao;
      this.dadosPaginacao.paginaSelecionada = 0;
      this.loadPartners();
    });
    this.loadPartners();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.partnersSub?.unsubscribe();
  }

  filterPartner(): void {
    this.dadosPaginacao.paginaSelecionada = 0;
    this.loadPartners();
  }

  clearfilters(): void {
    this.acaoInput.reset();
    this.dadosPaginacao.paginaSelecionada = 0;
    this.loadPartners();
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;
    this.loadPartners();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.loadPartners();
  }

  public downloadExcel(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    const filtros: IListByFilterEmpresas = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }
    this.companyService.exportarExcelEmpresas(filtros);
  }

  public loadPartners(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const accountRole = this.sessionService.getSession().accountRole;

    const filtros: IListByFilterParceiros = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (this.acaoInput.value) {
      filtros.searchText = String(this.acaoInput.value);
    }

    // Ordenação ou página trocadas em sequência: cancela a busca anterior para a resposta antiga não sobrescrever a nova.
    this.partnersSub?.unsubscribe();
    this.partnersSub = this.partnerService.listarTodosParceiros(filtros).subscribe({
      next: (resposta) => {
        this.partners = resposta.data;
        this.dadosPaginacao.totalPaginas = Math.ceil(resposta.count! / this.dadosPaginacao.tamanhoPagina);
        this.dadosPaginacao.itensTotal = resposta.count!;
      },
      // Falhou: não deixa na tela a lista da busca anterior como se fosse o resultado dos filtros atuais.
      error: (erro) => {
        this.partners = [];
        this.dadosPaginacao.totalPaginas = 0;
        this.dadosPaginacao.itensTotal = 0;
        if (!interceptorAvisouErro(erro)) {
          this.toastService.toast('Erro ao carregar os temas. Tente novamente.', EMessageType.Error);
        }
      }
    });
  }
}
